import { Platform } from 'react-native';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Trigger a browser download for a binary payload returned by a backend
 * `responseType: 'blob'` request. Web-only (mobile export is not wired).
 */
export function downloadBlobAsFile(data: BlobPart, filename: string, mime: string = XLSX_MIME): void {
  if (Platform.OS !== 'web') return;
  const blob = new Blob([data], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
